<lyceo-content *transloco="let t" [background]="true" [alternate]="true">
  <lyceo-single-card-layout>
    <homi-logo class="mb-5" header />
    <form (submit)="submit($event)">
      <p class="mb-3">
        {{ t('pages.choose_website.fill_institute_or_school') }}
      </p>
      <lyceo-form-field>
        <lyceo-form-label>{{
          t('pages.choose_website.name')
        }}</lyceo-form-label>
        <input
          data-testid="website-input"
          autocapitalize="none"
          lyceoInput
          type="text"
          [formField]="form.website"
        />
      </lyceo-form-field>

      <button
        data-testid="save"
        type="submit"
        [disabled]="settingsLoading() || form().invalid()"
        [block]="true"
        lyceoButton
      >
        {{ t('general.save') }}
      </button>
    </form>
  </lyceo-single-card-layout>
</lyceo-content>
